/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-09-24 19:52:05
 */
import React, { useMemo } from 'react'
import { useAppSelector } from '../../../app/hooks'

export default () => {
  // folder state 现在是普通对象
  const folderState = useAppSelector((state) => state.folder)

  const count = useMemo(() => {
    const photos = folderState.photos
    const checkedPhotos = folderState.checkedPhotos
    const unCheckedPhotos = folderState.unCheckedPhotos
    const checkAll = folderState.checkAll

    // 普通对象用 Object.keys().length 代替 .size
    if (checkAll) {
      return photos.length - Object.keys(unCheckedPhotos).length
    } else {
      return Object.keys(checkedPhotos).length
    }
  }, [folderState])

  return count
}
